import {Component, HostListener, OnInit} from '@angular/core';

import {Star, StarColor} from '../../../models/models';
import * as _ from 'lodash';

@Component({
  selector: 'longmoon-starfield',
  templateUrl: './starfield.component.html',
  styleUrls: ['./starfield.component.scss']
})
export class StarfieldComponent implements OnInit {
  starField: Star[];
  starfieldWidth = window.innerWidth;
  starfieldHeight = 265;
  starfieldNumber;

  constructor() {
  }

  ngOnInit(): void {
    this.countStars();
  }

  @HostListener('window:resize')
  countStars(): void {
    this.starfieldWidth = window.innerWidth;
    this.starfieldNumber = this.starfieldWidth * .2;
    this.starField = this.generateStars(this.starfieldWidth, this.starfieldHeight, this.starfieldNumber);
  }

  generateStars(
    width: number,
    height: number,
    numOfStars: number,
  ): any {

    const starField: Star[] = [];
    let iterator = 0;

    while (iterator <= numOfStars) {
      const xposition = Math.random();
      const yposition = Math.random();
      const period = Math.ceil((Math.random() * 7) + 2);

      starField.push(
        {
          x: Math.floor(width * xposition),
          y: Math.floor(height * yposition),
          period,
          color: _.sample(Object.values(StarColor)) as StarColor,
          size: 1
        }
      );

      iterator++;
    }

    return starField;
  }
}
